import { useTranslation } from "react-i18next";

import { IconDownloadCloud02, IconBookOpen02 } from "@pentabd/icons";
import { Button, Header } from "@pentabd/ui";
import { ReportType } from "@hooks/HRM/reports/useYearlyReports";

export const YearlyReportsPageHeader = ({
  downloadReport,
  selectedReport,
  isLoading,
}: {
  downloadReport: (fileName: string, downloadUrl: string) => void;
  selectedReport: ReportType | undefined;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconBookOpen02 size="20" />,
    },
    {
      label: t("REPORTS.YEARLY_REPORTS.HEADER"),
    },
  ];

  const handleDownload = async () => {
    downloadReport(
      selectedReport?.name || "",
      selectedReport?.downloadUrl || "",
    );
  };

  const headerText = {
    header: t("REPORTS.YEARLY_REPORTS.HEADER"),
  };

  console.log("selectedReport", selectedReport);

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={headerText}
      actions={[
        <Button
          type="primary"
          size="sm"
          onClick={handleDownload}
          loading={isLoading}
        >
          <IconDownloadCloud02 size="16" fill="white" />
          {t("REPORTS.DOWNLOAD_BTN")}
        </Button>,
      ]}
    />
  );
};

export default YearlyReportsPageHeader;
